import type { BorderStyledProps, ColorStyledProps, Theme } from '@viewup/ui';
import { Column, getColorValue, Icon, InProgressArrow, Typography, useTheme } from '@viewup/ui';
import { getStatusStyles, ICON_MAP } from './ProgressIcon.const';

export type ProgressIconType = 'apply' | 'edit' | 'submit';
export type ProgressIconStatus = 'notStarted' | 'disable' | 'inProgress' | 'done' | 'final';
export type ProgressIconColor = 'info' | 'danger';

export interface ProgressIconProps {
  color?: ProgressIconColor;
  label?: string;
  status: ProgressIconStatus;
  type: ProgressIconType;
  withOutArrow?: boolean;
}

const ProgressArrow = ({ color, theme }: { color: ProgressIconProps['color']; theme: Theme }) => (
  <InProgressArrow
    style={{
      color: color && getColorValue(`icon.${color}`, theme),
    }}
  />
);

const IconContainer = ({
  children,
  styleConfig,
}: {
  children: React.ReactNode;
  styleConfig: ColorStyledProps & BorderStyledProps;
}) => (
  <Column
    {...styleConfig}
    alignItems='center'
    css={{ borderRadius: 999, height: 32, width: 32 }}
    justifyContent='center'
  >
    {children}
  </Column>
);

export const ProgressIcon = ({ status, type, color, label }: ProgressIconProps) => {
  const theme = useTheme();
  const statusStyles = getStatusStyles(color);
  const showProgressArrow =
    status === 'inProgress' || status === 'final' || status === 'notStarted';

  return (
    <Column alignItems='center' gap={8}>
      {showProgressArrow && <ProgressArrow color={color} theme={theme} />}
      <IconContainer styleConfig={statusStyles[status]}>
        <Icon source={ICON_MAP[type]} />
      </IconContainer>
      <Typography color='text.tertiary' fontType='body2.regular'>
        {label}
      </Typography>
    </Column>
  );
};
